import React, { useState } from "react";
import "../styles/FromData.css";
import topImage from "../assets/top.png";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Navigate, useNavigate } from "react-router-dom";

const FormComponent = () => {
   const navigate = useNavigate();
   const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    firm_name: "",
    arc_name: "",
    designation: "",
    arcImage: null,
    arc_quote: "",
    contact_number: "",
    firm_website: "",
    personal_insta: "",
    firm_insta: "",
    personal_linkedin: "",
    firm_linkedin: "",
    projects_2025: [""],
    pick_up_location: "",
    drop_location: "Leela Bhartiya City, Bangalore",
    pick_up_time: "",
    evening_drop_location: "",
    event_day: "day2",
  });

  const normalizeUrl = (url) => {
    if (!url) return "";
    if (!/^https?:\/\//i.test(url)) {
      return `https://${url}`;
    }
    return url;
  };

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    const urlFields = [
      // "firm_website",
      // "personal_insta",
      // "firm_insta",
      // "personal_linkedin",
      // "firm_linkedin",
    ];
    let finalValue = value;

    if (urlFields.includes(name)) {
      finalValue = normalizeUrl(value.trim());
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "file" ? files[0] : finalValue,
    }));
  };

  const handleArrayChange = (e, index, key) => {
    const { value } = e.target;
    setFormData((prevData) => {
      const newArray = [...prevData[key]];
      newArray[index] = value;
      return { ...prevData, [key]: newArray };
    });
  };

  const addToArrayField = (key) => {
    setFormData((prevData) => ({
      ...prevData,
      [key]: [...prevData[key], ""],
    }));
  };

  const removeFromArrayField = (index, key) => {
    setFormData((prevData) => ({
      ...prevData,
      [key]: prevData[key].filter((_, i) => i !== index),
    }));
  };

  const validateForm = () => {
    const urlFields = [
      // "firm_website",
      // "firm_website",
      // "personal_insta",
      // "firm_insta",
      // "personal_linkedin",
      // "firm_linkedin",
    ];

    const urlRegex = /^(https?:\/\/)?([\w\-]+\.)+[\w\-]+(\/[\w\-./?%&=]*)?$/;

    const phoneRegex = /^[0-9]{10}$/;

    // if (!phoneRegex.test(formData.contact_number)) {
    //   toast.error("Enter a valid 10-digit contact number.");
    //   return false;
    // }

    for (let field of urlFields) {
      if (formData[field] && !urlRegex.test(formData[field])) {
        toast.error(`Invalid URL in ${field.replace("_", " ")}`);
        return false;
      }
    }

    // if (!formData.arcImage) {
    //   toast.error("Please upload a dignitary image.");
    //   return false;
    // }

    // if (
    //   formData.projects_2025.length === 0 ||
    //   formData.projects_2025.some((proj) => proj.trim() === "")
    // ) {
    //   toast.error("Please enter all 2025 project names.");
    //   return false;
    // }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);

    const form = new FormData();
    for (const key in formData) {
      if (key === "projects_2025") {
        formData[key].forEach((item) => form.append("projects_2025", item));
      } else if (key === "arcImage") {
        form.append("arcImage", formData[key]);
      } else {
        form.append(key, formData[key]);
      }
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/submit`,
        {
          method: "POST",
          body: form,
        }
      );

      if (response.ok) {
        const data = await response.json();
        toast.success(data.message || "Form submitted successfully!");
        setTimeout(() => {
          navigate("/success"); // assuming route is defined
        }, 1500);
        setFormData({
          firm_name: "",
          arc_name: "",
          designation: "",
          arcImage: null,
          arc_quote: "",
          contact_number: "",
          firm_website: "",
          personal_insta: "",
          firm_insta: "",
          personal_linkedin: "",
          firm_linkedin: "",
          projects_2025: [""],
          pick_up_location: "",
          drop_location: "Leela Bhartiya City, Bangalore",
          pick_up_time: "",
          evening_drop_location: "",
        });
      } else {
        const errorData = await response.json();
        toast.error(errorData.message || "Failed to submit form.");
      }
    } catch (err) {
      console.error("Submission error:", err);
      toast.error("Network error. Please try again.");
    } finally{
      setLoading(false);
    }
  };

  return (
    <div className="form-container">
      <ToastContainer />
      <img src={topImage} alt="Top Banner" />

      <h2>NAVIG8 VISION DIRECTORY DETAILS</h2>
      <h2 className="day">(DAY 2)</h2>
      <h3 className="date-venue">
        Date: July 24-25, 2025 l Venue: Leela Bhartiya City, Bangalore{" "}
      </h3>
      <h4>Important Instructions Before You Begin :</h4>
      <ul>
        <li>Please enter the details of the person attending the show.</li>
        <li>
          <strong>Preferred Attendee :</strong>Builder/Promoter , Builders
          Procurement Team,Facility Managers, PMC, Civil Engineers, Structural
          Engineers,Lead Consultants,Light Consultants ,M Consultants,Builders
          Architect Team,Builders Interior Team,Hospital Procurement Team,Hotel
          & Hospitality,International Buyers,Turnkey Constructions.
        </li>
        <li>
          The directory will be shared with participating brands prior to the
          show, allowing them to better understand your work and reach out
          meaningfully.{" "}
        </li>
        <li>
          Directory will be shared with key government bodies including Urban
          Development, Airports, Railways, Metro and other relevant
          infrastructure authorities.
        </li>
      </ul>

      <form onSubmit={handleSubmit}>
        {/* Company Name */}
        <div className="form-group">
          <label htmlFor="firm_name">Company Name :</label>
          <input
            type="text"
            id="firm_name"
            name="firm_name"
            value={formData.firm_name}
            onChange={handleChange}
            placeholder="Company name"
            
          />
        </div>

        {/* Visiting Dignitary Name */}
        <div className="form-group">
          <label htmlFor="arc_name">Visiting Dignitary Name :</label>
          <input
            type="text"
            id="arc_name"
            name="arc_name"
            value={formData.arc_name}
            onChange={handleChange}
            placeholder="Visiting dignitary name"
            
          />
        </div>

        {/* Designation */}
        <div className="form-group">
          <label htmlFor="designation">Designation :</label>
          <input
            type="text"
            id="designation"
            name="designation"
            value={formData.designation}
            onChange={handleChange}
            placeholder="Designation"
            
          />
        </div>

        {/* Image Upload */}
        <div className="form-group">
          <label htmlFor="arcImage">Visiting Dignitary Picture :</label>
          <input
            type="file"
            id="arcImage"
            name="arcImage"
            onChange={handleChange}
            accept="image/*"
            
          />
        </div>

        {/* Quote */}
        <div className="form-group">
          <label htmlFor="arc_quote">
            Visiting Dignitary Quote:
            <br />
            (A one-line vision statement for the real estate/building materials
            industry)
          </label>
          <textarea
            id="arc_quote"
            name="arc_quote"
            value={formData.arc_quote}
            onChange={handleChange}
            placeholder="Quote"
            
          />
        </div>

        {/* Contact Number */}
        <div className="form-group">
          <label htmlFor="contact_number">Contact Number :</label>
          <input
            type="tel"
            id="contact_number"
            name="contact_number"
            value={formData.contact_number}
            onChange={handleChange}
            placeholder="10-digit phone number"
            maxLength={10}
            minLength={10}
            
          />
        </div>

        {/* Website */}
        <div className="form-group">
          <label htmlFor="firm_website">Company Website :</label>
          {/* <span id="project2025">(copy-paste your link here)</span> */}
          <input
            type="text"
            id="firm_website"
            name="firm_website"
            value={formData.firm_website}
            onChange={handleChange}
            placeholder="Copy paste link here"
            
          />
        </div>

        {/* Social Media */}
        <h3 style={{ color: "grey" }}>Social Media Profiles : </h3>

        <div className="form-group">
          <label htmlFor="personal_insta">Personal Instagram :</label>
          {/* <span id="project2025">(copy-paste your link here)</span> */}
          <input
            type="url"
            id="personal_insta"
            name="personal_insta"
            value={formData.personal_insta}
            onChange={handleChange}
            placeholder="Copy paste link here"
            
          />
        </div>

        <div className="form-group">
          <label htmlFor="firm_insta">Company Instagram :</label>
          {/* <span id="project2025">(copy-paste your link here)</span> */}
          <input
            type="url"
            id="firm_insta"
            name="firm_insta"
            value={formData.firm_insta}
            onChange={handleChange}
            placeholder="Copy paste link here"
            
          />
        </div>

        <div className="form-group">
          <label htmlFor="personal_linkedin">Personal LinkedIn :</label>
          {/* <span id="project2025">(copy-paste your link here)</span> */}
          <input
            type="url"
            id="personal_linkedin"
            name="personal_linkedin"
            value={formData.personal_linkedin}
            onChange={handleChange}
            placeholder="Copy paste link here"
            
          />
        </div>

        <div className="form-group">
          <label htmlFor="firm_linkedin">Company LinkedIn :</label>
          {/* <span id="project2025">(copy-paste your link here)</span> */}
          <input
            type="url"
            id="firm_linkedin"
            name="firm_linkedin"
            value={formData.firm_linkedin}
            onChange={handleChange}
            placeholder="Copy paste link here"
            
          />
        </div>
        

        {/* Projects 2025 */}
        <div className="form-group">
          <label>
            Projects for 2025 (Ongoing & Upcoming) :{" "}
            <span id="required">*required</span>
          </label>
          {formData.projects_2025.map((project, index) => (
            <div key={`project-2025-${index}`} className="array-input">
              <input
                type="text"
                value={project}
                onChange={(e) => handleArrayChange(e, index, "projects_2025")}
                placeholder="Upcoming project"
                
              />
              {formData.projects_2025.length > 1 && (
                <button
                  type="button"
                  onClick={() => removeFromArrayField(index, "projects_2025")}
                >
                  Remove
                </button>
              )}
            </div>
          ))}
          <button
            type="button"
            onClick={() => addToArrayField("projects_2025")}
          >
            Add Project
          </button>
        </div>

        {/* Pick-up and drop info */}
        <div className="form-group">
          <label htmlFor="pick_up_location">Pick-up Location :</label>
          <input
            type="text"
            id="pick_up_location"
            name="pick_up_location"
            value={formData.pick_up_location}
            onChange={handleChange}
            placeholder="Your pickup address"
            
          />
        </div>

        <div className="form-group">
          <label htmlFor="drop_location">Drop-off Location :</label>
          <input
            type="text"
            id="drop_location"
            name="drop_location"
            value={formData.drop_location}
            readOnly
            
          />
        </div>

        <div className="form-group">
          <label htmlFor="pick_up_time">Pick-up Time :
            <br />
            (You're invited to the inaugural ceremony at 9:30 am. Kindly confirm your pick up time.)
          </label>
          <input
            type="datetime-local"
            id="pick_up_time"
            name="pick_up_time"
            value={formData.pick_up_time}
            onChange={handleChange}
            
          />
        </div>

        <div className="form-group">
          <label htmlFor="evening_drop_location">
            Evening Drop-off Location :
          </label>
          <input
            type="text"
            id="evening_drop_location"
            name="evening_drop_location"
            value={formData.evening_drop_location}
            onChange={handleChange}
            placeholder="Your drop address"
            
          />
        </div>

        <button type="submit" className="submit-button" disabled={loading}>
          {loading ? "Submitting..." : "Submit"}
        </button>
      </form>
    </div>
  );
};

export default FormComponent;
